<section class="events-header-wrap" [class.versionV2]="viewConfigurations.useMobileViewWithTopMenu">
  <div class="flex" *ngIf="!showNoEventsMessage; else noEventsForFilter">
    <div class="title-wrap">
      <div class="sport-text h2">
        <span>{{title}}</span>
      </div>
      <div class="text-wrap">
        <!-- <div class="region-name">{{subtitle}}</div> -->
        <div class="competition-title" *ngIf="srcSelection && srcSelection.sport && srcSelection.sport.id > 0">{{title}}
          <span class="events-number" *ngIf="eventsNumber > 0" >({{eventsNumber}})</span>
        </div>
        <div *ngIf="isMobileView" class="back btn primary small rounded" (click)="backToTree()">
          <ng-container i18n="Back button@@BackButton">Nazad</ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noEventsForFilter>
    <div class="title-wrap">
      <div class="text-wrap">
        <div class="h2 empty-h2" i18n="There are no events for the selected filter@@EmptyFilterResultEvents">Nema mečeva za odabrani filter</div>
        <div *ngIf="isMobileView" class="back btn primary small rounded" (click)="backToTree()">
          <ng-container i18n="Back button@@BackButton">Nazad</ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="league-title-wrap" *ngIf="tabs?.length > 0 && !showNoEventsMessage;">
    <ng-container *ngFor="let tab of tabs">

      <div *ngIf="tab.eventsCount > 0" [class.selected]="tab.isSelected"  (click)="selectTab(tab)">
        <ng-container *ngIf="tab.competitions && tabsType == eventHeaderTabTypeEnum.RegionAndCompetitions; else tabName">Sve</ng-container>
        <ng-template #tabName>{{tab.name}}</ng-template>
        <span class="events-number"> ({{tab.eventsCount}})</span>
      </div>
    </ng-container>
  </div>

</section>
